module.exports = __webpack_public_path__ + "img/icon-cities.7170f078.svg";